// --------------------------------------------------------------------------------
// Enums
// --------------------------------------------------------------------------------

/**
 * @example
 * ```graphql
 * enum AdjustmentType {
 *   DISTRIBUTED_ORDER_PROMOTION
 *   OTHER
 *   PROMOTION
 * }
 * ```
 */
export const AdjustmentType = Object.freeze({
  DISTRIBUTED_ORDER_PROMOTION: 'DISTRIBUTED_ORDER_PROMOTION',
  OTHER: 'OTHER',
  PROMOTION: 'PROMOTION'
});

/**
 * @example
 * ```graphql
 * enum AssetType {
 *   BINARY
 *   IMAGE
 *   VIDEO
 * }
 * ```
 */
export const AssetType = Object.freeze({
  BINARY: 'BINARY',
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO'
});

/**
 * @description
ISO 4217 currency code

@docsCategory common
 * 
 * @example
 * ```graphql
 * """
 * @description
 * ISO 4217 currency code
 * 
 * @docsCategory common
 * """
 * enum CurrencyCode {
 *   """United Arab Emirates dirham"""
 *   AED
 * 
 *   """Afghan afghani"""
 *   AFN
 * 
 *   """Albanian lek"""
 *   ALL
 * 
 *   """Armenian dram"""
 *   AMD
 * 
 *   """Netherlands Antillean guilder"""
 *   ANG
 * 
 *   """Angolan kwanza"""
 *   AOA
 * 
 *   """Argentine peso"""
 *   ARS
 * 
 *   """Australian dollar"""
 *   AUD
 * 
 *   """Aruban florin"""
 *   AWG
 * 
 *   """Azerbaijani manat"""
 *   AZN
 * 
 *   """Bosnia and Herzegovina convertible mark"""
 *   BAM
 * 
 *   """Barbados dollar"""
 *   BBD
 * 
 *   """Bangladeshi taka"""
 *   BDT
 * 
 *   """Bulgarian lev"""
 *   BGN
 * 
 *   """Bahraini dinar"""
 *   BHD
 * 
 *   """Burundian franc"""
 *   BIF
 * 
 *   """Bermudian dollar"""
 *   BMD
 * 
 *   """Brunei dollar"""
 *   BND
 * 
 *   """Boliviano"""
 *   BOB
 * 
 *   """Brazilian real"""
 *   BRL
 * 
 *   """Bahamian dollar"""
 *   BSD
 * 
 *   """Bhutanese ngultrum"""
 *   BTN
 * 
 *   """Botswana pula"""
 *   BWP
 * 
 *   """Belarusian ruble"""
 *   BYN
 * 
 *   """Belize dollar"""
 *   BZD
 * 
 *   """Canadian dollar"""
 *   CAD
 * 
 *   """Congolese franc"""
 *   CDF
 * 
 *   """Swiss franc"""
 *   CHF
 * 
 *   """Chilean peso"""
 *   CLP
 * 
 *   """Renminbi (Chinese) yuan"""
 *   CNY
 * 
 *   """Colombian peso"""
 *   COP
 * 
 *   """Costa Rican colon"""
 *   CRC
 * 
 *   """Cuban convertible peso"""
 *   CUC
 * 
 *   """Cuban peso"""
 *   CUP
 * 
 *   """Cape Verde escudo"""
 *   CVE
 * 
 *   """Czech koruna"""
 *   CZK
 * 
 *   """Djiboutian franc"""
 *   DJF
 * 
 *   """Danish krone"""
 *   DKK
 * 
 *   """Dominican peso"""
 *   DOP
 * 
 *   """Algerian dinar"""
 *   DZD
 * 
 *   """Egyptian pound"""
 *   EGP
 * 
 *   """Eritrean nakfa"""
 *   ERN
 * 
 *   """Ethiopian birr"""
 *   ETB
 * 
 *   """Euro"""
 *   EUR
 * 
 *   """Fiji dollar"""
 *   FJD
 * 
 *   """Falkland Islands pound"""
 *   FKP
 * 
 *   """Pound sterling"""
 *   GBP
 * 
 *   """Georgian lari"""
 *   GEL
 * 
 *   """Ghanaian cedi"""
 *   GHS
 * 
 *   """Gibraltar pound"""
 *   GIP
 * 
 *   """Gambian dalasi"""
 *   GMD
 * 
 *   """Guinean franc"""
 *   GNF
 * 
 *   """Guatemalan quetzal"""
 *   GTQ
 * 
 *   """Guyanese dollar"""
 *   GYD
 * 
 *   """Hong Kong dollar"""
 *   HKD
 * 
 *   """Honduran lempira"""
 *   HNL
 * 
 *   """Croatian kuna"""
 *   HRK
 * 
 *   """Haitian gourde"""
 *   HTG
 * 
 *   """Hungarian forint"""
 *   HUF
 * 
 *   """Indonesian rupiah"""
 *   IDR
 * 
 *   """Israeli new shekel"""
 *   ILS
 * 
 *   """Indian rupee"""
 *   INR
 * 
 *   """Iraqi dinar"""
 *   IQD
 * 
 *   """Iranian rial"""
 *   IRR
 * 
 *   """Icelandic króna"""
 *   ISK
 * 
 *   """Jamaican dollar"""
 *   JMD
 * 
 *   """Jordanian dinar"""
 *   JOD
 * 
 *   """Japanese yen"""
 *   JPY
 * 
 *   """Kenyan shilling"""
 *   KES
 * 
 *   """Kyrgyzstani som"""
 *   KGS
 * 
 *   """Cambodian riel"""
 *   KHR
 * 
 *   """Comoro franc"""
 *   KMF
 * 
 *   """North Korean won"""
 *   KPW
 * 
 *   """South Korean won"""
 *   KRW
 * 
 *   """Kuwaiti dinar"""
 *   KWD
 * 
 *   """Cayman Islands dollar"""
 *   KYD
 * 
 *   """Kazakhstani tenge"""
 *   KZT
 * 
 *   """Lao kip"""
 *   LAK
 * 
 *   """Lebanese pound"""
 *   LBP
 * 
 *   """Sri Lankan rupee"""
 *   LKR
 * 
 *   """Liberian dollar"""
 *   LRD
 * 
 *   """Lesotho loti"""
 *   LSL
 * 
 *   """Libyan dinar"""
 *   LYD
 * 
 *   """Moroccan dirham"""
 *   MAD
 * 
 *   """Moldovan leu"""
 *   MDL
 * 
 *   """Malagasy ariary"""
 *   MGA
 * 
 *   """Macedonian denar"""
 *   MKD
 * 
 *   """Myanmar kyat"""
 *   MMK
 * 
 *   """Mongolian tögrög"""
 *   MNT
 * 
 *   """Macanese pataca"""
 *   MOP
 * 
 *   """Mauritanian ouguiya"""
 *   MRU
 * 
 *   """Mauritian rupee"""
 *   MUR
 * 
 *   """Maldivian rufiyaa"""
 *   MVR
 * 
 *   """Malawian kwacha"""
 *   MWK
 * 
 *   """Mexican peso"""
 *   MXN
 * 
 *   """Malaysian ringgit"""
 *   MYR
 * 
 *   """Mozambican metical"""
 *   MZN
 * 
 *   """Namibian dollar"""
 *   NAD
 * 
 *   """Nigerian naira"""
 *   NGN
 * 
 *   """Nicaraguan córdoba"""
 *   NIO
 * 
 *   """Norwegian krone"""
 *   NOK
 * 
 *   """Nepalese rupee"""
 *   NPR
 * 
 *   """New Zealand dollar"""
 *   NZD
 * 
 *   """Omani rial"""
 *   OMR
 * 
 *   """Panamanian balboa"""
 *   PAB
 * 
 *   """Peruvian sol"""
 *   PEN
 * 
 *   """Papua New Guinean kina"""
 *   PGK
 * 
 *   """Philippine peso"""
 *   PHP
 * 
 *   """Pakistani rupee"""
 *   PKR
 * 
 *   """Polish złoty"""
 *   PLN
 * 
 *   """Paraguayan guaraní"""
 *   PYG
 * 
 *   """Qatari riyal"""
 *   QAR
 * 
 *   """Romanian leu"""
 *   RON
 * 
 *   """Serbian dinar"""
 *   RSD
 * 
 *   """Russian ruble"""
 *   RUB
 * 
 *   """Rwandan franc"""
 *   RWF
 * 
 *   """Saudi riyal"""
 *   SAR
 * 
 *   """Solomon Islands dollar"""
 *   SBD
 * 
 *   """Seychelles rupee"""
 *   SCR
 * 
 *   """Sudanese pound"""
 *   SDG
 * 
 *   """Swedish krona/kronor"""
 *   SEK
 * 
 *   """Singapore dollar"""
 *   SGD
 * 
 *   """Saint Helena pound"""
 *   SHP
 * 
 *   """Sierra Leonean leone"""
 *   SLL
 * 
 *   """Somali shilling"""
 *   SOS
 * 
 *   """Surinamese dollar"""
 *   SRD
 * 
 *   """South Sudanese pound"""
 *   SSP
 * 
 *   """São Tomé and Príncipe dobra"""
 *   STN
 * 
 *   """Salvadoran colón"""
 *   SVC
 * 
 *   """Syrian pound"""
 *   SYP
 * 
 *   """Swazi lilangeni"""
 *   SZL
 * 
 *   """Thai baht"""
 *   THB
 * 
 *   """Tajikistani somoni"""
 *   TJS
 * 
 *   """Turkmenistan manat"""
 *   TMT
 * 
 *   """Tunisian dinar"""
 *   TND
 * 
 *   """Tongan paʻanga"""
 *   TOP
 * 
 *   """Turkish lira"""
 *   TRY
 * 
 *   """Trinidad and Tobago dollar"""
 *   TTD
 * 
 *   """New Taiwan dollar"""
 *   TWD
 * 
 *   """Tanzanian shilling"""
 *   TZS
 * 
 *   """Ukrainian hryvnia"""
 *   UAH
 * 
 *   """Ugandan shilling"""
 *   UGX
 * 
 *   """United States dollar"""
 *   USD
 * 
 *   """Uruguayan peso"""
 *   UYU
 * 
 *   """Uzbekistan som"""
 *   UZS
 * 
 *   """Venezuelan bolívar soberano"""
 *   VES
 * 
 *   """Vietnamese đồng"""
 *   VND
 * 
 *   """Vanuatu vatu"""
 *   VUV
 * 
 *   """Samoan tala"""
 *   WST
 * 
 *   """CFA franc BEAC"""
 *   XAF
 * 
 *   """East Caribbean dollar"""
 *   XCD
 * 
 *   """CFA franc BCEAO"""
 *   XOF
 * 
 *   """CFP franc (franc Pacifique)"""
 *   XPF
 * 
 *   """Yemeni rial"""
 *   YER
 * 
 *   """South African rand"""
 *   ZAR
 * 
 *   """Zambian kwacha"""
 *   ZMW
 * 
 *   """Zimbabwean dollar"""
 *   ZWL
 * }
 * ```
 */
export const CurrencyCode = Object.freeze({
  /** United Arab Emirates dirham */
  AED: 'AED',
  /** Afghan afghani */
  AFN: 'AFN',
  /** Albanian lek */
  ALL: 'ALL',
  /** Armenian dram */
  AMD: 'AMD',
  /** Netherlands Antillean guilder */
  ANG: 'ANG',
  /** Angolan kwanza */
  AOA: 'AOA',
  /** Argentine peso */
  ARS: 'ARS',
  /** Australian dollar */
  AUD: 'AUD',
  /** Aruban florin */
  AWG: 'AWG',
  /** Azerbaijani manat */
  AZN: 'AZN',
  /** Bosnia and Herzegovina convertible mark */
  BAM: 'BAM',
  /** Barbados dollar */
  BBD: 'BBD',
  /** Bangladeshi taka */
  BDT: 'BDT',
  /** Bulgarian lev */
  BGN: 'BGN',
  /** Bahraini dinar */
  BHD: 'BHD',
  /** Burundian franc */
  BIF: 'BIF',
  /** Bermudian dollar */
  BMD: 'BMD',
  /** Brunei dollar */
  BND: 'BND',
  /** Boliviano */
  BOB: 'BOB',
  /** Brazilian real */
  BRL: 'BRL',
  /** Bahamian dollar */
  BSD: 'BSD',
  /** Bhutanese ngultrum */
  BTN: 'BTN',
  /** Botswana pula */
  BWP: 'BWP',
  /** Belarusian ruble */
  BYN: 'BYN',
  /** Belize dollar */
  BZD: 'BZD',
  /** Canadian dollar */
  CAD: 'CAD',
  /** Congolese franc */
  CDF: 'CDF',
  /** Swiss franc */
  CHF: 'CHF',
  /** Chilean peso */
  CLP: 'CLP',
  /** Renminbi (Chinese) yuan */
  CNY: 'CNY',
  /** Colombian peso */
  COP: 'COP',
  /** Costa Rican colon */
  CRC: 'CRC',
  /** Cuban convertible peso */
  CUC: 'CUC',
  /** Cuban peso */
  CUP: 'CUP',
  /** Cape Verde escudo */
  CVE: 'CVE',
  /** Czech koruna */
  CZK: 'CZK',
  /** Djiboutian franc */
  DJF: 'DJF',
  /** Danish krone */
  DKK: 'DKK',
  /** Dominican peso */
  DOP: 'DOP',
  /** Algerian dinar */
  DZD: 'DZD',
  /** Egyptian pound */
  EGP: 'EGP',
  /** Eritrean nakfa */
  ERN: 'ERN',
  /** Ethiopian birr */
  ETB: 'ETB',
  /** Euro */
  EUR: 'EUR',
  /** Fiji dollar */
  FJD: 'FJD',
  /** Falkland Islands pound */
  FKP: 'FKP',
  /** Pound sterling */
  GBP: 'GBP',
  /** Georgian lari */
  GEL: 'GEL',
  /** Ghanaian cedi */
  GHS: 'GHS',
  /** Gibraltar pound */
  GIP: 'GIP',
  /** Gambian dalasi */
  GMD: 'GMD',
  /** Guinean franc */
  GNF: 'GNF',
  /** Guatemalan quetzal */
  GTQ: 'GTQ',
  /** Guyanese dollar */
  GYD: 'GYD',
  /** Hong Kong dollar */
  HKD: 'HKD',
  /** Honduran lempira */
  HNL: 'HNL',
  /** Croatian kuna */
  HRK: 'HRK',
  /** Haitian gourde */
  HTG: 'HTG',
  /** Hungarian forint */
  HUF: 'HUF',
  /** Indonesian rupiah */
  IDR: 'IDR',
  /** Israeli new shekel */
  ILS: 'ILS',
  /** Indian rupee */
  INR: 'INR',
  /** Iraqi dinar */
  IQD: 'IQD',
  /** Iranian rial */
  IRR: 'IRR',
  /** Icelandic króna */
  ISK: 'ISK',
  /** Jamaican dollar */
  JMD: 'JMD',
  /** Jordanian dinar */
  JOD: 'JOD',
  /** Japanese yen */
  JPY: 'JPY',
  /** Kenyan shilling */
  KES: 'KES',
  /** Kyrgyzstani som */
  KGS: 'KGS',
  /** Cambodian riel */
  KHR: 'KHR',
  /** Comoro franc */
  KMF: 'KMF',
  /** North Korean won */
  KPW: 'KPW',
  /** South Korean won */
  KRW: 'KRW',
  /** Kuwaiti dinar */
  KWD: 'KWD',
  /** Cayman Islands dollar */
  KYD: 'KYD',
  /** Kazakhstani tenge */
  KZT: 'KZT',
  /** Lao kip */
  LAK: 'LAK',
  /** Lebanese pound */
  LBP: 'LBP',
  /** Sri Lankan rupee */
  LKR: 'LKR',
  /** Liberian dollar */
  LRD: 'LRD',
  /** Lesotho loti */
  LSL: 'LSL',
  /** Libyan dinar */
  LYD: 'LYD',
  /** Moroccan dirham */
  MAD: 'MAD',
  /** Moldovan leu */
  MDL: 'MDL',
  /** Malagasy ariary */
  MGA: 'MGA',
  /** Macedonian denar */
  MKD: 'MKD',
  /** Myanmar kyat */
  MMK: 'MMK',
  /** Mongolian tögrög */
  MNT: 'MNT',
  /** Macanese pataca */
  MOP: 'MOP',
  /** Mauritanian ouguiya */
  MRU: 'MRU',
  /** Mauritian rupee */
  MUR: 'MUR',
  /** Maldivian rufiyaa */
  MVR: 'MVR',
  /** Malawian kwacha */
  MWK: 'MWK',
  /** Mexican peso */
  MXN: 'MXN',
  /** Malaysian ringgit */
  MYR: 'MYR',
  /** Mozambican metical */
  MZN: 'MZN',
  /** Namibian dollar */
  NAD: 'NAD',
  /** Nigerian naira */
  NGN: 'NGN',
  /** Nicaraguan córdoba */
  NIO: 'NIO',
  /** Norwegian krone */
  NOK: 'NOK',
  /** Nepalese rupee */
  NPR: 'NPR',
  /** New Zealand dollar */
  NZD: 'NZD',
  /** Omani rial */
  OMR: 'OMR',
  /** Panamanian balboa */
  PAB: 'PAB',
  /** Peruvian sol */
  PEN: 'PEN',
  /** Papua New Guinean kina */
  PGK: 'PGK',
  /** Philippine peso */
  PHP: 'PHP',
  /** Pakistani rupee */
  PKR: 'PKR',
  /** Polish złoty */
  PLN: 'PLN',
  /** Paraguayan guaraní */
  PYG: 'PYG',
  /** Qatari riyal */
  QAR: 'QAR',
  /** Romanian leu */
  RON: 'RON',
  /** Serbian dinar */
  RSD: 'RSD',
  /** Russian ruble */
  RUB: 'RUB',
  /** Rwandan franc */
  RWF: 'RWF',
  /** Saudi riyal */
  SAR: 'SAR',
  /** Solomon Islands dollar */
  SBD: 'SBD',
  /** Seychelles rupee */
  SCR: 'SCR',
  /** Sudanese pound */
  SDG: 'SDG',
  /** Swedish krona/kronor */
  SEK: 'SEK',
  /** Singapore dollar */
  SGD: 'SGD',
  /** Saint Helena pound */
  SHP: 'SHP',
  /** Sierra Leonean leone */
  SLL: 'SLL',
  /** Somali shilling */
  SOS: 'SOS',
  /** Surinamese dollar */
  SRD: 'SRD',
  /** South Sudanese pound */
  SSP: 'SSP',
  /** São Tomé and Príncipe dobra */
  STN: 'STN',
  /** Salvadoran colón */
  SVC: 'SVC',
  /** Syrian pound */
  SYP: 'SYP',
  /** Swazi lilangeni */
  SZL: 'SZL',
  /** Thai baht */
  THB: 'THB',
  /** Tajikistani somoni */
  TJS: 'TJS',
  /** Turkmenistan manat */
  TMT: 'TMT',
  /** Tunisian dinar */
  TND: 'TND',
  /** Tongan paʻanga */
  TOP: 'TOP',
  /** Turkish lira */
  TRY: 'TRY',
  /** Trinidad and Tobago dollar */
  TTD: 'TTD',
  /** New Taiwan dollar */
  TWD: 'TWD',
  /** Tanzanian shilling */
  TZS: 'TZS',
  /** Ukrainian hryvnia */
  UAH: 'UAH',
  /** Ugandan shilling */
  UGX: 'UGX',
  /** United States dollar */
  USD: 'USD',
  /** Uruguayan peso */
  UYU: 'UYU',
  /** Uzbekistan som */
  UZS: 'UZS',
  /** Venezuelan bolívar soberano */
  VES: 'VES',
  /** Vietnamese đồng */
  VND: 'VND',
  /** Vanuatu vatu */
  VUV: 'VUV',
  /** Samoan tala */
  WST: 'WST',
  /** CFA franc BEAC */
  XAF: 'XAF',
  /** East Caribbean dollar */
  XCD: 'XCD',
  /** CFA franc BCEAO */
  XOF: 'XOF',
  /** CFP franc (franc Pacifique) */
  XPF: 'XPF',
  /** Yemeni rial */
  YER: 'YER',
  /** South African rand */
  ZAR: 'ZAR',
  /** Zambian kwacha */
  ZMW: 'ZMW',
  /** Zimbabwean dollar */
  ZWL: 'ZWL'
});

/**
 * @example
 * ```graphql
 * enum DisputeEscalationLevel {
 *   AdminArbitration
 *   CustomerSeller
 *   LegalArbitration
 * }
 * ```
 */
export const DisputeEscalationLevel = Object.freeze({
  AdminArbitration: 'AdminArbitration',
  CustomerSeller: 'CustomerSeller',
  LegalArbitration: 'LegalArbitration'
});

/**
 * @example
 * ```graphql
 * enum DisputeProposalState {
 *   Accepted
 *   Pending
 *   Rejected
 * }
 * ```
 */
export const DisputeProposalState = Object.freeze({
  Accepted: 'Accepted',
  Pending: 'Pending',
  Rejected: 'Rejected'
});

/**
 * Enumerates the reasons for an RMA dispute, specifying whether the product was not received or received.
 * 
 * @example
 * ```graphql
 * """
 * Enumerates the reasons for an RMA dispute, specifying whether the product was not received or received.
 * """
 * enum DisputeReason {
 *   CanceledOrderBeforeShipment
 *   DamageDuringShipping
 *   GoodsTakenByCustoms
 *   ItIsOverDeliveryTime
 *   ItemArrivedLate
 *   ItemNotReceived
 *   MissingPartsInTheProduct
 *   NotSatisfiedWithTheProduct
 *   OtherIssues
 *   PackageIsHoldInCustoms
 *   PackageIsReturnedToSellerByShippingCompany
 *   PackageIsShipToAWrongAddress
 *   ProductDoesntMatchDescription
 *   ProductDoesntWorkOrIsIncompatible
 *   ProductHasABadSmell
 *   ProductInWorseConditionThanDescribed
 *   ProductIsDamaged
 *   ProductIsDamagedInTransit
 *   ProductIsDamagedOrFaulty
 *   ProductIsMissingParts
 *   ProductIsNotAsDescribed
 *   ProductLooksFakeOrCounterfeit
 *   ProductWithQualityIssue
 *   ReceivedFewerItemsThanOrdered
 *   ThereIsNoTrackingInformation
 *   UnauthorizedPayment
 *   WrongColorReceived
 *   WrongSizeReceived
 * }
 * ```
 */
export const DisputeReason = Object.freeze({
  CanceledOrderBeforeShipment: 'CanceledOrderBeforeShipment',
  DamageDuringShipping: 'DamageDuringShipping',
  GoodsTakenByCustoms: 'GoodsTakenByCustoms',
  ItIsOverDeliveryTime: 'ItIsOverDeliveryTime',
  ItemArrivedLate: 'ItemArrivedLate',
  ItemNotReceived: 'ItemNotReceived',
  MissingPartsInTheProduct: 'MissingPartsInTheProduct',
  NotSatisfiedWithTheProduct: 'NotSatisfiedWithTheProduct',
  OtherIssues: 'OtherIssues',
  PackageIsHoldInCustoms: 'PackageIsHoldInCustoms',
  PackageIsReturnedToSellerByShippingCompany: 'PackageIsReturnedToSellerByShippingCompany',
  PackageIsShipToAWrongAddress: 'PackageIsShipToAWrongAddress',
  ProductDoesntMatchDescription: 'ProductDoesntMatchDescription',
  ProductDoesntWorkOrIsIncompatible: 'ProductDoesntWorkOrIsIncompatible',
  ProductHasABadSmell: 'ProductHasABadSmell',
  ProductInWorseConditionThanDescribed: 'ProductInWorseConditionThanDescribed',
  ProductIsDamaged: 'ProductIsDamaged',
  ProductIsDamagedInTransit: 'ProductIsDamagedInTransit',
  ProductIsDamagedOrFaulty: 'ProductIsDamagedOrFaulty',
  ProductIsMissingParts: 'ProductIsMissingParts',
  ProductIsNotAsDescribed: 'ProductIsNotAsDescribed',
  ProductLooksFakeOrCounterfeit: 'ProductLooksFakeOrCounterfeit',
  ProductWithQualityIssue: 'ProductWithQualityIssue',
  ReceivedFewerItemsThanOrdered: 'ReceivedFewerItemsThanOrdered',
  ThereIsNoTrackingInformation: 'ThereIsNoTrackingInformation',
  UnauthorizedPayment: 'UnauthorizedPayment',
  WrongColorReceived: 'WrongColorReceived',
  WrongSizeReceived: 'WrongSizeReceived'
});

/**
 * @example
 * ```graphql
 * enum DisputeState {
 *   Cancelled
 *   Completed
 *   Created
 *   PendingCustomerAction
 *   PendingSellerAction
 * }
 * ```
 */
export const DisputeState = Object.freeze({
  Cancelled: 'Cancelled',
  Completed: 'Completed',
  Created: 'Created',
  PendingCustomerAction: 'PendingCustomerAction',
  PendingSellerAction: 'PendingSellerAction'
});

/**
 * @example
 * ```graphql
 * enum DisputeType {
 *   """
 *   Dispute type: Product not received.
 *   Haven't received your order:
 *   It's over delivery time;
 *   There is no tracking information;
 *   Package is returned to seller by shipping company;
 *   Package is hold in customs;
 *   Package is ship to a wrong address;
 *   """
 *   ProductNotReceived
 * 
 *   """
 *   Dispute type: Product received.
 *   Products received, but seller cannot help to solve the product issue (pls contact seller first):
 *   Product with quality issue;
 *   Product is not as described;
 *   Product is damaged;
 *   Product is damaged in transit;
 *   Product is missing parts;
 *   Other issues;
 *   """
 *   ProductReceived
 * }
 * ```
 */
export const DisputeType = Object.freeze({
  /**
   * Dispute type: Product not received.
   * Haven't received your order:
   * It's over delivery time;
   * There is no tracking information;
   * Package is returned to seller by shipping company;
   * Package is hold in customs;
   * Package is ship to a wrong address;
   */
  ProductNotReceived: 'ProductNotReceived',
  /**
   * Dispute type: Product received.
   * Products received, but seller cannot help to solve the product issue (pls contact seller first):
   * Product with quality issue;
   * Product is not as described;
   * Product is damaged;
   * Product is damaged in transit;
   * Product is missing parts;
   * Other issues;
   */
  ProductReceived: 'ProductReceived'
});

/**
 * Enumerates the possible verdicts/outcomes for an RMA dispute.
 * 
 * @example
 * ```graphql
 * """Enumerates the possible verdicts/outcomes for an RMA dispute."""
 * enum DisputeVerdict {
 *   Canceled
 *   Fraud
 *   Other
 *   Refund
 *   TimeOut
 * }
 * ```
 */
export const DisputeVerdict = Object.freeze({
  Canceled: 'Canceled',
  Fraud: 'Fraud',
  Other: 'Other',
  Refund: 'Refund',
  TimeOut: 'TimeOut'
});

/**
 * @example
 * ```graphql
 * enum ErrorCode {
 *   ACTIVE_DISPUTE_PROPOSAL_ALREADY_EXIST_ERROR
 *   ALREADY_LOGGED_IN_ERROR
 *   COUPON_CODE_EXPIRED_ERROR
 *   COUPON_CODE_INVALID_ERROR
 *   COUPON_CODE_LIMIT_ERROR
 *   CREATE_PRODUCT_REVIEW_ERROR
 *   CUSTOMER_NOT_FOUND_ERROR
 *   DISPUTE_ALREADY_EXIST_ERROR
 *   DISPUTE_NOT_FOUND_ERROR
 *   DISPUTE_PROPOSAL_STATE_TRANSITION_ERROR
 *   DISPUTE_STATE_TRANSITION_ERROR
 *   EMAIL_ADDRESS_CONFLICT_ERROR
 *   GUEST_CHECKOUT_ERROR
 *   IDENTIFIER_CHANGE_TOKEN_EXPIRED_ERROR
 *   IDENTIFIER_CHANGE_TOKEN_INVALID_ERROR
 *   INELIGIBLE_PAYMENT_METHOD_ERROR
 *   INELIGIBLE_SHIPPING_METHOD_ERROR
 *   INSUFFICIENT_STOCK_ERROR
 *   INTERNAL_ORACLE_ERROR
 *   INVALID_CREDENTIALS_ERROR
 *   MIME_TYPE_ERROR
 *   MISSING_PASSWORD_ERROR
 *   NATIVE_AUTH_STRATEGY_ERROR
 *   NEGATIVE_QUANTITY_ERROR
 *   NOT_VERIFIED_ERROR
 *   NO_ACTIVE_ORDER_ERROR
 *   ORDER_HAS_NOT_FULFILLMENTS_ERROR
 *   ORDER_HAS_NO_VALID_FULFILLMENTS_ERROR
 *   ORDER_INTERCEPTOR_ERROR
 *   ORDER_LIMIT_ERROR
 *   ORDER_LINE_NOT_FOUND_ERROR
 *   ORDER_MODIFICATION_ERROR
 *   ORDER_PAYMENT_STATE_ERROR
 *   ORDER_STATE_TRANSITION_ERROR
 *   PASSWORD_ALREADY_SET_ERROR
 *   PASSWORD_RESET_TOKEN_EXPIRED_ERROR
 *   PASSWORD_RESET_TOKEN_INVALID_ERROR
 *   PASSWORD_VALIDATION_ERROR
 *   PAYMENT_DECLINED_ERROR
 *   PAYMENT_FAILED_ERROR
 *   PRODUCT_REVIEW_ASSET_MIME_TYPE_ERROR
 *   REVIEW_AUTHOR_NOT_FOUND
 *   REVIEW_BODY_TOO_LONG
 *   REVIEW_BODY_TOO_SHORT
 *   REVIEW_PRODUCT_NOT_FOUND
 *   REVIEW_PRODUCT_VARIANT_NOT_FOUND
 *   REVIEW_SUMMARY_TOO_LONG
 *   REVIEW_SUMMARY_TOO_SHORT
 *   UNKNOWN_ERROR
 *   UNSUPPORTED_COUNTRY_CODE_ERROR
 *   VERIFICATION_TOKEN_EXPIRED_ERROR
 *   VERIFICATION_TOKEN_INVALID_ERROR
 * }
 * ```
 */
export const ErrorCode = Object.freeze({
  ACTIVE_DISPUTE_PROPOSAL_ALREADY_EXIST_ERROR: 'ACTIVE_DISPUTE_PROPOSAL_ALREADY_EXIST_ERROR',
  ALREADY_LOGGED_IN_ERROR: 'ALREADY_LOGGED_IN_ERROR',
  COUPON_CODE_EXPIRED_ERROR: 'COUPON_CODE_EXPIRED_ERROR',
  COUPON_CODE_INVALID_ERROR: 'COUPON_CODE_INVALID_ERROR',
  COUPON_CODE_LIMIT_ERROR: 'COUPON_CODE_LIMIT_ERROR',
  CREATE_PRODUCT_REVIEW_ERROR: 'CREATE_PRODUCT_REVIEW_ERROR',
  CUSTOMER_NOT_FOUND_ERROR: 'CUSTOMER_NOT_FOUND_ERROR',
  DISPUTE_ALREADY_EXIST_ERROR: 'DISPUTE_ALREADY_EXIST_ERROR',
  DISPUTE_NOT_FOUND_ERROR: 'DISPUTE_NOT_FOUND_ERROR',
  DISPUTE_PROPOSAL_STATE_TRANSITION_ERROR: 'DISPUTE_PROPOSAL_STATE_TRANSITION_ERROR',
  DISPUTE_STATE_TRANSITION_ERROR: 'DISPUTE_STATE_TRANSITION_ERROR',
  EMAIL_ADDRESS_CONFLICT_ERROR: 'EMAIL_ADDRESS_CONFLICT_ERROR',
  GUEST_CHECKOUT_ERROR: 'GUEST_CHECKOUT_ERROR',
  IDENTIFIER_CHANGE_TOKEN_EXPIRED_ERROR: 'IDENTIFIER_CHANGE_TOKEN_EXPIRED_ERROR',
  IDENTIFIER_CHANGE_TOKEN_INVALID_ERROR: 'IDENTIFIER_CHANGE_TOKEN_INVALID_ERROR',
  INELIGIBLE_PAYMENT_METHOD_ERROR: 'INELIGIBLE_PAYMENT_METHOD_ERROR',
  INELIGIBLE_SHIPPING_METHOD_ERROR: 'INELIGIBLE_SHIPPING_METHOD_ERROR',
  INSUFFICIENT_STOCK_ERROR: 'INSUFFICIENT_STOCK_ERROR',
  INTERNAL_ORACLE_ERROR: 'INTERNAL_ORACLE_ERROR',
  INVALID_CREDENTIALS_ERROR: 'INVALID_CREDENTIALS_ERROR',
  MIME_TYPE_ERROR: 'MIME_TYPE_ERROR',
  MISSING_PASSWORD_ERROR: 'MISSING_PASSWORD_ERROR',
  NATIVE_AUTH_STRATEGY_ERROR: 'NATIVE_AUTH_STRATEGY_ERROR',
  NEGATIVE_QUANTITY_ERROR: 'NEGATIVE_QUANTITY_ERROR',
  NOT_VERIFIED_ERROR: 'NOT_VERIFIED_ERROR',
  NO_ACTIVE_ORDER_ERROR: 'NO_ACTIVE_ORDER_ERROR',
  ORDER_HAS_NOT_FULFILLMENTS_ERROR: 'ORDER_HAS_NOT_FULFILLMENTS_ERROR',
  ORDER_HAS_NO_VALID_FULFILLMENTS_ERROR: 'ORDER_HAS_NO_VALID_FULFILLMENTS_ERROR',
  ORDER_INTERCEPTOR_ERROR: 'ORDER_INTERCEPTOR_ERROR',
  ORDER_LIMIT_ERROR: 'ORDER_LIMIT_ERROR',
  ORDER_LINE_NOT_FOUND_ERROR: 'ORDER_LINE_NOT_FOUND_ERROR',
  ORDER_MODIFICATION_ERROR: 'ORDER_MODIFICATION_ERROR',
  ORDER_PAYMENT_STATE_ERROR: 'ORDER_PAYMENT_STATE_ERROR',
  ORDER_STATE_TRANSITION_ERROR: 'ORDER_STATE_TRANSITION_ERROR',
  PASSWORD_ALREADY_SET_ERROR: 'PASSWORD_ALREADY_SET_ERROR',
  PASSWORD_RESET_TOKEN_EXPIRED_ERROR: 'PASSWORD_RESET_TOKEN_EXPIRED_ERROR',
  PASSWORD_RESET_TOKEN_INVALID_ERROR: 'PASSWORD_RESET_TOKEN_INVALID_ERROR',
  PASSWORD_VALIDATION_ERROR: 'PASSWORD_VALIDATION_ERROR',
  PAYMENT_DECLINED_ERROR: 'PAYMENT_DECLINED_ERROR',
  PAYMENT_FAILED_ERROR: 'PAYMENT_FAILED_ERROR',
  PRODUCT_REVIEW_ASSET_MIME_TYPE_ERROR: 'PRODUCT_REVIEW_ASSET_MIME_TYPE_ERROR',
  REVIEW_AUTHOR_NOT_FOUND: 'REVIEW_AUTHOR_NOT_FOUND',
  REVIEW_BODY_TOO_LONG: 'REVIEW_BODY_TOO_LONG',
  REVIEW_BODY_TOO_SHORT: 'REVIEW_BODY_TOO_SHORT',
  REVIEW_PRODUCT_NOT_FOUND: 'REVIEW_PRODUCT_NOT_FOUND',
  REVIEW_PRODUCT_VARIANT_NOT_FOUND: 'REVIEW_PRODUCT_VARIANT_NOT_FOUND',
  REVIEW_SUMMARY_TOO_LONG: 'REVIEW_SUMMARY_TOO_LONG',
  REVIEW_SUMMARY_TOO_SHORT: 'REVIEW_SUMMARY_TOO_SHORT',
  UNKNOWN_ERROR: 'UNKNOWN_ERROR',
  UNSUPPORTED_COUNTRY_CODE_ERROR: 'UNSUPPORTED_COUNTRY_CODE_ERROR',
  VERIFICATION_TOKEN_EXPIRED_ERROR: 'VERIFICATION_TOKEN_EXPIRED_ERROR',
  VERIFICATION_TOKEN_INVALID_ERROR: 'VERIFICATION_TOKEN_INVALID_ERROR'
});

/**
 * @example
 * ```graphql
 * enum GCXAudioEncoding {
 *   AUDIO_ENCODING_AMR
 *   AUDIO_ENCODING_AMR_WB
 *   AUDIO_ENCODING_FLAC
 *   AUDIO_ENCODING_LINEAR_16
 *   AUDIO_ENCODING_MULAW
 *   AUDIO_ENCODING_OGG_OPUS
 *   AUDIO_ENCODING_SPEEX_WITH_HEADER_BYTE
 *   AUDIO_ENCODING_UNSPECIFIED
 * }
 * ```
 */
export const GcxAudioEncoding = Object.freeze({
  AUDIO_ENCODING_AMR: 'AUDIO_ENCODING_AMR',
  AUDIO_ENCODING_AMR_WB: 'AUDIO_ENCODING_AMR_WB',
  AUDIO_ENCODING_FLAC: 'AUDIO_ENCODING_FLAC',
  AUDIO_ENCODING_LINEAR_16: 'AUDIO_ENCODING_LINEAR_16',
  AUDIO_ENCODING_MULAW: 'AUDIO_ENCODING_MULAW',
  AUDIO_ENCODING_OGG_OPUS: 'AUDIO_ENCODING_OGG_OPUS',
  AUDIO_ENCODING_SPEEX_WITH_HEADER_BYTE: 'AUDIO_ENCODING_SPEEX_WITH_HEADER_BYTE',
  AUDIO_ENCODING_UNSPECIFIED: 'AUDIO_ENCODING_UNSPECIFIED'
});

/**
 * @example
 * ```graphql
 * enum GCXEntityOverrideMode {
 *   ENTITY_OVERRIDE_MODE_OVERRIDE
 *   ENTITY_OVERRIDE_MODE_SUPPLEMENT
 *   ENTITY_OVERRIDE_MODE_UNSPECIFIED
 * }
 * ```
 */
export const GcxEntityOverrideMode = Object.freeze({
  ENTITY_OVERRIDE_MODE_OVERRIDE: 'ENTITY_OVERRIDE_MODE_OVERRIDE',
  ENTITY_OVERRIDE_MODE_SUPPLEMENT: 'ENTITY_OVERRIDE_MODE_SUPPLEMENT',
  ENTITY_OVERRIDE_MODE_UNSPECIFIED: 'ENTITY_OVERRIDE_MODE_UNSPECIFIED'
});

/**
 * @example
 * ```graphql
 * enum GCXMatchType {
 *   DIRECT_INTENT
 *   EVENT
 *   INTENT
 *   MATCH_TYPE_UNSPECIFIED
 *   NO_INPUT
 *   NO_MATCH
 *   PARAMETER_FILLING
 * }
 * ```
 */
export const GcxMatchType = Object.freeze({
  DIRECT_INTENT: 'DIRECT_INTENT',
  EVENT: 'EVENT',
  INTENT: 'INTENT',
  MATCH_TYPE_UNSPECIFIED: 'MATCH_TYPE_UNSPECIFIED',
  NO_INPUT: 'NO_INPUT',
  NO_MATCH: 'NO_MATCH',
  PARAMETER_FILLING: 'PARAMETER_FILLING'
});

/**
 * @example
 * ```graphql
 * enum GCXOutputAudioEncoding {
 *   OUTPUT_AUDIO_ENCODING_LINEAR_16
 *   OUTPUT_AUDIO_ENCODING_MP3
 *   OUTPUT_AUDIO_ENCODING_MP3_64_KBPS
 *   OUTPUT_AUDIO_ENCODING_MULAW
 *   OUTPUT_AUDIO_ENCODING_OGG_OPUS
 *   OUTPUT_AUDIO_ENCODING_UNSPECIFIED
 * }
 * ```
 */
export const GcxOutputAudioEncoding = Object.freeze({
  OUTPUT_AUDIO_ENCODING_LINEAR_16: 'OUTPUT_AUDIO_ENCODING_LINEAR_16',
  OUTPUT_AUDIO_ENCODING_MP3: 'OUTPUT_AUDIO_ENCODING_MP3',
  OUTPUT_AUDIO_ENCODING_MP3_64_KBPS: 'OUTPUT_AUDIO_ENCODING_MP3_64_KBPS',
  OUTPUT_AUDIO_ENCODING_MULAW: 'OUTPUT_AUDIO_ENCODING_MULAW',
  OUTPUT_AUDIO_ENCODING_OGG_OPUS: 'OUTPUT_AUDIO_ENCODING_OGG_OPUS',
  OUTPUT_AUDIO_ENCODING_UNSPECIFIED: 'OUTPUT_AUDIO_ENCODING_UNSPECIFIED'
});

/**
 * @example
 * ```graphql
 * enum GCXResponseType {
 *   FINAL
 *   PARTIAL
 *   RESPONSE_TYPE_UNSPECIFIED
 * }
 * ```
 */
export const GcxResponseType = Object.freeze({
  FINAL: 'FINAL',
  PARTIAL: 'PARTIAL',
  RESPONSE_TYPE_UNSPECIFIED: 'RESPONSE_TYPE_UNSPECIFIED'
});

/**
 * @example
 * ```graphql
 * enum GCXSpeechModelVariant {
 *   SPEECH_MODEL_VARIANT_UNSPECIFIED
 *   USE_BEST_AVAILABLE
 *   USE_ENHANCED
 *   USE_STANDARD
 * }
 * ```
 */
export const GcxSpeechModelVariant = Object.freeze({
  SPEECH_MODEL_VARIANT_UNSPECIFIED: 'SPEECH_MODEL_VARIANT_UNSPECIFIED',
  USE_BEST_AVAILABLE: 'USE_BEST_AVAILABLE',
  USE_ENHANCED: 'USE_ENHANCED',
  USE_STANDARD: 'USE_STANDARD'
});

/**
 * @example
 * ```graphql
 * enum GCXSsmlVoiceGender {
 *   SSML_VOICE_GENDER_FEMALE
 *   SSML_VOICE_GENDER_MALE
 *   SSML_VOICE_GENDER_NEUTRAL
 *   SSML_VOICE_GENDER_UNSPECIFIED
 * }
 * ```
 */
export const GcxSsmlVoiceGender = Object.freeze({
  SSML_VOICE_GENDER_FEMALE: 'SSML_VOICE_GENDER_FEMALE',
  SSML_VOICE_GENDER_MALE: 'SSML_VOICE_GENDER_MALE',
  SSML_VOICE_GENDER_NEUTRAL: 'SSML_VOICE_GENDER_NEUTRAL',
  SSML_VOICE_GENDER_UNSPECIFIED: 'SSML_VOICE_GENDER_UNSPECIFIED'
});

/**
 * @description
Languages in the form of a ISO 639-1 language code with optional
region or script modifier (e.g. de_AT). The selection available is based
on the [Unicode CLDR summary list](https://unicode-org.github.io/cldr-staging/charts/37/summary/root.html)
and includes the major spoken languages of the world and any widely-used variants.

@docsCategory common
 * 
 * @example
 * ```graphql
 * """
 * @description
 * Languages in the form of a ISO 639-1 language code with optional
 * region or script modifier (e.g. de_AT). The selection available is based
 * on the [Unicode CLDR summary list](https://unicode-org.github.io/cldr-staging/charts/37/summary/root.html)
 * and includes the major spoken languages of the world and any widely-used variants.
 * 
 * @docsCategory common
 * """
 * enum LanguageCode {
 *   """Afrikaans"""
 *   af
 * 
 *   """Akan"""
 *   ak
 * 
 *   """Amharic"""
 *   am
 * 
 *   """Arabic"""
 *   ar
 * 
 *   """Assamese"""
 *   as
 * 
 *   """Azerbaijani"""
 *   az
 * 
 *   """Belarusian"""
 *   be
 * 
 *   """Bulgarian"""
 *   bg
 * 
 *   """Bambara"""
 *   bm
 * 
 *   """Bangla"""
 *   bn
 * 
 *   """Tibetan"""
 *   bo
 * 
 *   """Breton"""
 *   br
 * 
 *   """Bosnian"""
 *   bs
 * 
 *   """Catalan"""
 *   ca
 * 
 *   """Chechen"""
 *   ce
 * 
 *   """Corsican"""
 *   co
 * 
 *   """Czech"""
 *   cs
 * 
 *   """Church Slavic"""
 *   cu
 * 
 *   """Welsh"""
 *   cy
 * 
 *   """Danish"""
 *   da
 * 
 *   """German"""
 *   de
 * 
 *   """Austrian German"""
 *   de_AT
 * 
 *   """Swiss High German"""
 *   de_CH
 * 
 *   """Dzongkha"""
 *   dz
 * 
 *   """Ewe"""
 *   ee
 * 
 *   """Greek"""
 *   el
 * 
 *   """English"""
 *   en
 * 
 *   """Australian English"""
 *   en_AU
 * 
 *   """Canadian English"""
 *   en_CA
 * 
 *   """British English"""
 *   en_GB
 * 
 *   """American English"""
 *   en_US
 * 
 *   """Esperanto"""
 *   eo
 * 
 *   """Spanish"""
 *   es
 * 
 *   """European Spanish"""
 *   es_ES
 * 
 *   """Mexican Spanish"""
 *   es_MX
 * 
 *   """Estonian"""
 *   et
 * 
 *   """Basque"""
 *   eu
 * 
 *   """Persian"""
 *   fa
 * 
 *   """Dari"""
 *   fa_AF
 * 
 *   """Fulah"""
 *   ff
 * 
 *   """Finnish"""
 *   fi
 * 
 *   """Faroese"""
 *   fo
 * 
 *   """French"""
 *   fr
 * 
 *   """Canadian French"""
 *   fr_CA
 * 
 *   """Swiss French"""
 *   fr_CH
 * 
 *   """Western Frisian"""
 *   fy
 * 
 *   """Irish"""
 *   ga
 * 
 *   """Scottish Gaelic"""
 *   gd
 * 
 *   """Galician"""
 *   gl
 * 
 *   """Gujarati"""
 *   gu
 * 
 *   """Manx"""
 *   gv
 * 
 *   """Hausa"""
 *   ha
 * 
 *   """Hebrew"""
 *   he
 * 
 *   """Hindi"""
 *   hi
 * 
 *   """Croatian"""
 *   hr
 * 
 *   """Haitian Creole"""
 *   ht
 * 
 *   """Hungarian"""
 *   hu
 * 
 *   """Armenian"""
 *   hy
 * 
 *   """Interlingua"""
 *   ia
 * 
 *   """Indonesian"""
 *   id
 * 
 *   """Igbo"""
 *   ig
 * 
 *   """Sichuan Yi"""
 *   ii
 * 
 *   """Icelandic"""
 *   is
 * 
 *   """Italian"""
 *   it
 * 
 *   """Japanese"""
 *   ja
 * 
 *   """Javanese"""
 *   jv
 * 
 *   """Georgian"""
 *   ka
 * 
 *   """Kikuyu"""
 *   ki
 * 
 *   """Kazakh"""
 *   kk
 * 
 *   """Kalaallisut"""
 *   kl
 * 
 *   """Khmer"""
 *   km
 * 
 *   """Kannada"""
 *   kn
 * 
 *   """Korean"""
 *   ko
 * 
 *   """Kashmiri"""
 *   ks
 * 
 *   """Kurdish"""
 *   ku
 * 
 *   """Cornish"""
 *   kw
 * 
 *   """Kyrgyz"""
 *   ky
 * 
 *   """Latin"""
 *   la
 * 
 *   """Luxembourgish"""
 *   lb
 * 
 *   """Ganda"""
 *   lg
 * 
 *   """Lingala"""
 *   ln
 * 
 *   """Lao"""
 *   lo
 * 
 *   """Lithuanian"""
 *   lt
 * 
 *   """Luba-Katanga"""
 *   lu
 * 
 *   """Latvian"""
 *   lv
 * 
 *   """Malagasy"""
 *   mg
 * 
 *   """Maori"""
 *   mi
 * 
 *   """Macedonian"""
 *   mk
 * 
 *   """Malayalam"""
 *   ml
 * 
 *   """Mongolian"""
 *   mn
 * 
 *   """Marathi"""
 *   mr
 * 
 *   """Malay"""
 *   ms
 * 
 *   """Maltese"""
 *   mt
 * 
 *   """Burmese"""
 *   my
 * 
 *   """Norwegian Bokmål"""
 *   nb
 * 
 *   """North Ndebele"""
 *   nd
 * 
 *   """Nepali"""
 *   ne
 * 
 *   """Dutch"""
 *   nl
 * 
 *   """Flemish"""
 *   nl_BE
 * 
 *   """Norwegian Nynorsk"""
 *   nn
 * 
 *   """Nyanja"""
 *   ny
 * 
 *   """Oromo"""
 *   om
 * 
 *   """Odia"""
 *   or
 * 
 *   """Ossetic"""
 *   os
 * 
 *   """Punjabi"""
 *   pa
 * 
 *   """Polish"""
 *   pl
 * 
 *   """Pashto"""
 *   ps
 * 
 *   """Portuguese"""
 *   pt
 * 
 *   """Brazilian Portuguese"""
 *   pt_BR
 * 
 *   """European Portuguese"""
 *   pt_PT
 * 
 *   """Quechua"""
 *   qu
 * 
 *   """Romansh"""
 *   rm
 * 
 *   """Rundi"""
 *   rn
 * 
 *   """Romanian"""
 *   ro
 * 
 *   """Moldavian"""
 *   ro_MD
 * 
 *   """Russian"""
 *   ru
 * 
 *   """Kinyarwanda"""
 *   rw
 * 
 *   """Sanskrit"""
 *   sa
 * 
 *   """Sindhi"""
 *   sd
 * 
 *   """Northern Sami"""
 *   se
 * 
 *   """Sango"""
 *   sg
 * 
 *   """Sinhala"""
 *   si
 * 
 *   """Slovak"""
 *   sk
 * 
 *   """Slovenian"""
 *   sl
 * 
 *   """Samoan"""
 *   sm
 * 
 *   """Shona"""
 *   sn
 * 
 *   """Somali"""
 *   so
 * 
 *   """Albanian"""
 *   sq
 * 
 *   """Serbian"""
 *   sr
 * 
 *   """Southern Sotho"""
 *   st
 * 
 *   """Sundanese"""
 *   su
 * 
 *   """Swedish"""
 *   sv
 * 
 *   """Swahili"""
 *   sw
 * 
 *   """Congo Swahili"""
 *   sw_CD
 * 
 *   """Tamil"""
 *   ta
 * 
 *   """Telugu"""
 *   te
 * 
 *   """Tajik"""
 *   tg
 * 
 *   """Thai"""
 *   th
 * 
 *   """Tigrinya"""
 *   ti
 * 
 *   """Turkmen"""
 *   tk
 * 
 *   """Tongan"""
 *   to
 * 
 *   """Turkish"""
 *   tr
 * 
 *   """Tatar"""
 *   tt
 * 
 *   """Uyghur"""
 *   ug
 * 
 *   """Ukrainian"""
 *   uk
 * 
 *   """Urdu"""
 *   ur
 * 
 *   """Uzbek"""
 *   uz
 * 
 *   """Vietnamese"""
 *   vi
 * 
 *   """Volapük"""
 *   vo
 * 
 *   """Wolof"""
 *   wo
 * 
 *   """Xhosa"""
 *   xh
 * 
 *   """Yiddish"""
 *   yi
 * 
 *   """Yoruba"""
 *   yo
 * 
 *   """Chinese"""
 *   zh
 * 
 *   """Simplified Chinese"""
 *   zh_Hans
 * 
 *   """Traditional Chinese"""
 *   zh_Hant
 * 
 *   """Zulu"""
 *   zu
 * }
 * ```
 */
export const LanguageCode = Object.freeze({
  /** Afrikaans */
  af: 'af',
  /** Akan */
  ak: 'ak',
  /** Amharic */
  am: 'am',
  /** Arabic */
  ar: 'ar',
  /** Assamese */
  as: 'as',
  /** Azerbaijani */
  az: 'az',
  /** Belarusian */
  be: 'be',
  /** Bulgarian */
  bg: 'bg',
  /** Bambara */
  bm: 'bm',
  /** Bangla */
  bn: 'bn',
  /** Tibetan */
  bo: 'bo',
  /** Breton */
  br: 'br',
  /** Bosnian */
  bs: 'bs',
  /** Catalan */
  ca: 'ca',
  /** Chechen */
  ce: 'ce',
  /** Corsican */
  co: 'co',
  /** Czech */
  cs: 'cs',
  /** Church Slavic */
  cu: 'cu',
  /** Welsh */
  cy: 'cy',
  /** Danish */
  da: 'da',
  /** German */
  de: 'de',
  /** Austrian German */
  de_AT: 'de_AT',
  /** Swiss High German */
  de_CH: 'de_CH',
  /** Dzongkha */
  dz: 'dz',
  /** Ewe */
  ee: 'ee',
  /** Greek */
  el: 'el',
  /** English */
  en: 'en',
  /** Australian English */
  en_AU: 'en_AU',
  /** Canadian English */
  en_CA: 'en_CA',
  /** British English */
  en_GB: 'en_GB',
  /** American English */
  en_US: 'en_US',
  /** Esperanto */
  eo: 'eo',
  /** Spanish */
  es: 'es',
  /** European Spanish */
  es_ES: 'es_ES',
  /** Mexican Spanish */
  es_MX: 'es_MX',
  /** Estonian */
  et: 'et',
  /** Basque */
  eu: 'eu',
  /** Persian */
  fa: 'fa',
  /** Dari */
  fa_AF: 'fa_AF',
  /** Fulah */
  ff: 'ff',
  /** Finnish */
  fi: 'fi',
  /** Faroese */
  fo: 'fo',
  /** French */
  fr: 'fr',
  /** Canadian French */
  fr_CA: 'fr_CA',
  /** Swiss French */
  fr_CH: 'fr_CH',
  /** Western Frisian */
  fy: 'fy',
  /** Irish */
  ga: 'ga',
  /** Scottish Gaelic */
  gd: 'gd',
  /** Galician */
  gl: 'gl',
  /** Gujarati */
  gu: 'gu',
  /** Manx */
  gv: 'gv',
  /** Hausa */
  ha: 'ha',
  /** Hebrew */
  he: 'he',
  /** Hindi */
  hi: 'hi',
  /** Croatian */
  hr: 'hr',
  /** Haitian Creole */
  ht: 'ht',
  /** Hungarian */
  hu: 'hu',
  /** Armenian */
  hy: 'hy',
  /** Interlingua */
  ia: 'ia',
  /** Indonesian */
  id: 'id',
  /** Igbo */
  ig: 'ig',
  /** Sichuan Yi */
  ii: 'ii',
  /** Icelandic */
  is: 'is',
  /** Italian */
  it: 'it',
  /** Japanese */
  ja: 'ja',
  /** Javanese */
  jv: 'jv',
  /** Georgian */
  ka: 'ka',
  /** Kikuyu */
  ki: 'ki',
  /** Kazakh */
  kk: 'kk',
  /** Kalaallisut */
  kl: 'kl',
  /** Khmer */
  km: 'km',
  /** Kannada */
  kn: 'kn',
  /** Korean */
  ko: 'ko',
  /** Kashmiri */
  ks: 'ks',
  /** Kurdish */
  ku: 'ku',
  /** Cornish */
  kw: 'kw',
  /** Kyrgyz */
  ky: 'ky',
  /** Latin */
  la: 'la',
  /** Luxembourgish */
  lb: 'lb',
  /** Ganda */
  lg: 'lg',
  /** Lingala */
  ln: 'ln',
  /** Lao */
  lo: 'lo',
  /** Lithuanian */
  lt: 'lt',
  /** Luba-Katanga */
  lu: 'lu',
  /** Latvian */
  lv: 'lv',
  /** Malagasy */
  mg: 'mg',
  /** Maori */
  mi: 'mi',
  /** Macedonian */
  mk: 'mk',
  /** Malayalam */
  ml: 'ml',
  /** Mongolian */
  mn: 'mn',
  /** Marathi */
  mr: 'mr',
  /** Malay */
  ms: 'ms',
  /** Maltese */
  mt: 'mt',
  /** Burmese */
  my: 'my',
  /** Norwegian Bokmål */
  nb: 'nb',
  /** North Ndebele */
  nd: 'nd',
  /** Nepali */
  ne: 'ne',
  /** Dutch */
  nl: 'nl',
  /** Flemish */
  nl_BE: 'nl_BE',
  /** Norwegian Nynorsk */
  nn: 'nn',
  /** Nyanja */
  ny: 'ny',
  /** Oromo */
  om: 'om',
  /** Odia */
  or: 'or',
  /** Ossetic */
  os: 'os',
  /** Punjabi */
  pa: 'pa',
  /** Polish */
  pl: 'pl',
  /** Pashto */
  ps: 'ps',
  /** Portuguese */
  pt: 'pt',
  /** Brazilian Portuguese */
  pt_BR: 'pt_BR',
  /** European Portuguese */
  pt_PT: 'pt_PT',
  /** Quechua */
  qu: 'qu',
  /** Romansh */
  rm: 'rm',
  /** Rundi */
  rn: 'rn',
  /** Romanian */
  ro: 'ro',
  /** Moldavian */
  ro_MD: 'ro_MD',
  /** Russian */
  ru: 'ru',
  /** Kinyarwanda */
  rw: 'rw',
  /** Sanskrit */
  sa: 'sa',
  /** Sindhi */
  sd: 'sd',
  /** Northern Sami */
  se: 'se',
  /** Sango */
  sg: 'sg',
  /** Sinhala */
  si: 'si',
  /** Slovak */
  sk: 'sk',
  /** Slovenian */
  sl: 'sl',
  /** Samoan */
  sm: 'sm',
  /** Shona */
  sn: 'sn',
  /** Somali */
  so: 'so',
  /** Albanian */
  sq: 'sq',
  /** Serbian */
  sr: 'sr',
  /** Southern Sotho */
  st: 'st',
  /** Sundanese */
  su: 'su',
  /** Swedish */
  sv: 'sv',
  /** Swahili */
  sw: 'sw',
  /** Congo Swahili */
  sw_CD: 'sw_CD',
  /** Tamil */
  ta: 'ta',
  /** Telugu */
  te: 'te',
  /** Tajik */
  tg: 'tg',
  /** Thai */
  th: 'th',
  /** Tigrinya */
  ti: 'ti',
  /** Turkmen */
  tk: 'tk',
  /** Tongan */
  to: 'to',
  /** Turkish */
  tr: 'tr',
  /** Tatar */
  tt: 'tt',
  /** Uyghur */
  ug: 'ug',
  /** Ukrainian */
  uk: 'uk',
  /** Urdu */
  ur: 'ur',
  /** Uzbek */
  uz: 'uz',
  /** Vietnamese */
  vi: 'vi',
  /** Volapük */
  vo: 'vo',
  /** Wolof */
  wo: 'wo',
  /** Xhosa */
  xh: 'xh',
  /** Yiddish */
  yi: 'yi',
  /** Yoruba */
  yo: 'yo',
  /** Chinese */
  zh: 'zh',
  /** Simplified Chinese */
  zh_Hans: 'zh_Hans',
  /** Traditional Chinese */
  zh_Hant: 'zh_Hant',
  /** Zulu */
  zu: 'zu'
});

/**
 * @example
 * ```graphql
 * enum LogicalOperator {
 *   AND
 *   OR
 * }
 * ```
 */
export const LogicalOperator = Object.freeze({
  AND: 'AND',
  OR: 'OR'
});

/**
 * @example
 * ```graphql
 * enum SortOrder {
 *   ASC
 *   DESC
 * }
 * ```
 */
export const SortOrder = Object.freeze({
  ASC: 'ASC',
  DESC: 'DESC'
});